/** Sort additional / standalone services by persisted line order (product_index). */
export const sortServicesByProductIndex = (services) =>
  [...(services || [])].sort(
    (a, b) =>
      (Number(a?.product_index ?? a?.newIndexId ?? a?.indexId) || 0) -
      (Number(b?.product_index ?? b?.newIndexId ?? b?.indexId) || 0),
  )

/** Match a service row by line index only (not labour_cost_service_id / request_services PK). */
export const serviceLineMatches = (service, lineKey) => {
  if (lineKey === undefined || lineKey === null || lineKey === '') return false
  const key = String(lineKey)
  return (
    String(service?.newIndexId ?? '') === key ||
    String(service?.indexId ?? '') === key
  )
}

/** Build old product_index -> new position map for reorder-estimate-services API. */
export const buildServiceIndexMapping = (sortedServices) => {
  const indexIdMap = {}
  ;(sortedServices || []).forEach((s, idx) => {
    const oldIndex = Number(s?.product_index ?? s?.newIndexId ?? s?.indexId)
    if (!Number.isNaN(oldIndex) && oldIndex > 0) {
      indexIdMap[String(oldIndex)] = idx + 1
    }
  })
  return indexIdMap
}
